import { Router } from '@angular/router';
import { environment } from '@app/env';
var AppHeaderComponent = /** @class */ (function () {
    function AppHeaderComponent(router) {
        this.router = router;
    }
    Object.defineProperty(AppHeaderComponent.prototype, "isIOSApp", {
        get: function () {
            return this.isIOS && environment.isCordova;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppHeaderComponent.prototype, "isIOS", {
        get: function () {
            return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window['MSStream'];
        },
        enumerable: true,
        configurable: true
    });
    return AppHeaderComponent;
}());
export { AppHeaderComponent };
